import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useCallback } from 'react';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';

interface DeleteTimesheetDialogProps {
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  timesheetId?: string;
}

export function DeleteTimesheetDialog({
  isDeleting,
  onClose,
  onDelete,
  timesheetId,
}: DeleteTimesheetDialogProps) {
  const closeDialog = useCallback(() => {
    if (!isDeleting) {
      onClose();
    }
  }, [isDeleting, onClose]);

  return (
    <ConfirmationDialog
      confirmButtonProps={{ children: t('actions.remove_time_sheet') }}
      isBusy={isDeleting}
      isOpen={Boolean(timesheetId)}
      onClose={closeDialog}
      onConfirm={onDelete}
      title={t('actions.remove_time_sheet')}
    >
      <Typography>{t('approvals.driver_day.confirm_removing_time_sheet')}</Typography>
    </ConfirmationDialog>
  );
}
